export const GET_ALL_STORE_LIST = {
    INIT: 'GET_ALL_STORE_LIST_INIT',
    SUCCESS: 'GET_ALL_STORE_LIST_SUCCESS',
    ERROR: 'GET_ALL_STORE_LIST_ERROR'
}

export const SEARCHED_STORE_LIST = {
    SET: 'SEARCHED_STORE_LIST_SET'
}